import { Record } from 'immutable';
import { handleActions } from 'redux-actions';
import {
  EMAIL_CONFIRMATION_PAGE_LOAD_REQUESTED,
  EMAIL_CONFIRMATION_PAGE_LOAD_SUCCEEDED,
  EMAIL_CONFIRMATION_PAGE_LOAD_FAILED,
} from '../actions';

export const ReducerRecord = Record({
  error: false,
  loaded: false,
  fetching: false,
});

export default handleActions({
  [EMAIL_CONFIRMATION_PAGE_LOAD_REQUESTED](state) {
    return state.set('fetching', true);
  },
  [EMAIL_CONFIRMATION_PAGE_LOAD_SUCCEEDED](state) {
    return state
      .set('error', false)
      .set('loaded', true)
      .set('fetching', false);
  },
  [EMAIL_CONFIRMATION_PAGE_LOAD_FAILED](state) {
    return state
      .set('error', true)
      .set('loaded', true)
      .set('fetching', false);
  },
}, new ReducerRecord());
